// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1gmyM","header":"ReportDetails_header__1R_11","title":"ReportDetails_title__27dNw","left":"ReportDetails_left__3JbeS"};